import { render, staticRenderFns } from "./EarnBox.vue?vue&type=template&id=2ee32f78&scoped=true"
import script from "./EarnBox.vue?vue&type=script&lang=js"
export * from "./EarnBox.vue?vue&type=script&lang=js"
import style0 from "./EarnBox.vue?vue&type=style&index=0&id=2ee32f78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee32f78",
  null
  
)

export default component.exports